import { takeEvery } from "redux-saga/effects";
import changeNotificationsStatusWorker from "./changeNotificationsStatusWorker";
import getNotificationsWorker from "./getNotificationsWorker";

export function* notificationsWatcher() {
    yield takeEvery("notifications/getNotificationsFetch", getNotificationsWorker);
    yield takeEvery("notifications/changeNotificationsStatusFetch", changeNotificationsStatusWorker);
}